import './team-badge.styles.scss';
import { textColorOn } from '@shared/teamList.js';

// A faint edge and drop shadow, so a white ring still shows on a white page.
const OUTLINE = '0 0 0 1px rgba(0, 0, 0, .12), 0 1px 3px rgba(0, 0, 0, .3)';

// A team's "logo": its abbreviation on its primary color, ringed in its
// secondary color. size: 'sm' (lists), 'md' (default), 'lg' (headers).
const TeamBadge = ({ team, size = 'md' }) => {
    if (!team) return null;
    const color1 = team.color1 ?? '#666666';
    const color2 = team.color2 ?? '#ffffff';
    const abbr = team.abbr ?? team.name?.slice(0, 3).toUpperCase() ?? '';
    return (
        <span
            className={`team-badge ${size} ${abbr.length >= 4 ? 'long' : ''}`}
            style={{ backgroundColor: color1, color: textColorOn(color1), boxShadow: `inset 0 0 0 3px ${color2}, ${OUTLINE}` }}
            title={team.mascot ? `${team.name} ${team.mascot}` : team.name}
            aria-hidden='true'>
            {abbr}
        </span>
    )
}

export default TeamBadge
